import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
// import { ModalQrcodeComponent } from '@modals/modal-qrcode/modal-qrcode.component';
import { EnumQRCodeType } from '@models/Common';
// import { IUserCard } from '@models/Wallet';

@Component({
    selector: 'debit-card',
    templateUrl: './debit-card.component.html',
    styleUrls: ['./debit-card.component.scss'],
})
export class DebitCardComponent implements OnInit {

    @Input('data') Data: any// IUserCard;

    public OnlyVirtual: boolean = true;

    constructor(private ModalController: ModalController) { }

    ngOnInit() {


        console.log(this.Data);
        
        this.OnlyVirtual = this.Data?.OnlyVirtual ?? true;
    }
}
